import { themeClasses as T, C } from "../../atlas/utils";

interface DotProgressProps {
  total: number;
  completed: number;
}

export function DotProgress({ total, completed }: DotProgressProps) {
  return (
    <div
      role="progressbar"
      aria-valuenow={completed}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={`Progress: ${completed} out of ${total} completed`}
      className="flex items-center flex-wrap gap-2"
    >
      {[...Array(total)].map((_, index) => {
        const isCompleted = index < completed;

        return (
          <div
            aria-hidden="true"
            key={index}
            className={C(
              "w-4 h-4 rounded-full shrink-0",
              isCompleted ? T.bgIndigoDataviz1 : T.bgIndigoDataviz5
            )}
          />
        );
      })}
    </div>
  );
}
